'use client';

import {ChevronRight} from 'lucide-react';

import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from '@/shadcn_components/ui/collapsible';
import {
  SidebarGroup,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarMenuSub,
  SidebarMenuSubItem,
} from '@/shadcn_components/ui/sidebar';
import {SidebarMenuItem as SidebarMenuItemProps} from '@/routes/sidebar-menu-items';
import {Link} from 'react-router-dom';

export function NavMain({items}: {items: SidebarMenuItemProps[]}) {
  return (
    <SidebarGroup>
      {/* <SidebarGroupLabel>Quản lý</SidebarGroupLabel> */}
      <SidebarMenu>
        {items.map(item =>
          item.submenu ? (
            <MenuItemCollapsible item={item} key={item.title} />
          ) : (
            <MenuItemSubitem subItem={item} iconShow={true} key={item.title} />
          ),
        )}
      </SidebarMenu>
    </SidebarGroup>
  );
}

const MenuItemCollapsible = ({item}: {item: SidebarMenuItemProps}) => {
  return (
    <Collapsible hidden={item.hidden} key={item.title} asChild defaultOpen={item.isActive} className="group/collapsible">
      <SidebarMenuItem>
        <CollapsibleTrigger asChild>
          <SidebarMenuButton
            tooltip={item.title}
            className="hover:border hover:border-primary hover:bg-sidebar-accent hover:text-accent-foreground">
            {item.icon}
            <span>{item.title}</span>
            <ChevronRight className="ml-auto transition-transform duration-200 group-data-[state=open]/collapsible:rotate-90" />
          </SidebarMenuButton>
        </CollapsibleTrigger>
        <CollapsibleContent>
          <SidebarMenuSub>
            {item.submenu?.map(subItem => (
              <MenuItemSubitem subItem={subItem} key={subItem.title} />
            ))}
          </SidebarMenuSub>
        </CollapsibleContent>
      </SidebarMenuItem>
    </Collapsible>
  );
};

const MenuItemSubitem = ({
  subItem,
  iconShow = false,
}: {
  subItem: SidebarMenuItemProps;
  iconShow?: boolean;
}) => {
  return (
    <SidebarMenuSubItem key={subItem.title} hidden={subItem.hidden}>
      <SidebarMenuButton
        asChild
        className="hover:border hover:border-primary hover:bg-sidebar-accent hover:text-accent-foreground">
        <Link to={subItem.path}>
          {iconShow && subItem.icon}
          <span>{subItem.title}</span>
        </Link>
      </SidebarMenuButton>
    </SidebarMenuSubItem>
  );
};
